import { Button, Col, Divider, Row } from "antd";
import SelectInput from "../../components/inputs/SelectInput";
import { Form, Formik } from "formik";
import * as Yup from 'yup';
import { useCallback, useEffect, useState } from "react";
import { getData, postData, updateData } from "../../helpers/api";
import TextInput from "../../components/inputs/TextInput";
import { Tabs } from 'antd';
import moment from "moment";
import TableLayout from "../../components/layouts/TableLayout";
import DateInput from "../../components/inputs/DateInput";
import PaymentCard from "../../components/PaymentCard";
import {NumberOutlined, DollarOutlined} from "@ant-design/icons"
const { TabPane } = Tabs;

const ManagementPayment = () => {
    const [users, setUsers] = useState([])
    const [userId, setUserId] = useState(null)
    const [paymentData, setPaymentData] = useState(null)
    const [monthPaymentData, setMonthPaymentData] = useState(null)
    const [paymentHistory, setPaymentHistory] = useState({
        payments: [],
        total: 0
    })
    const [salaryHistory, setSalaryHistory] = useState({
        salary: [],
        total: 0
    })
    const getUsers = async () => {
        try {
            const res = await getData('/users/managements')
            setUsers(res.data.map((user) => ({ value: user.id, label: user.name })))
        } catch (error) {

        }
    }
    const getpaymentData = useCallback(async () => {
        try {
            const res = await getData('/payment/managers', { userId })
            setPaymentData(res.data)
        } catch (error) {

        }
    }, [userId])

    const getPaymentHistory = useCallback(async (page = 1, limit = 10) => {
        try {
            const res = await getData('/payment/history', { userId, page, limit })
            setPaymentHistory(res.data)
        } catch (error) {

        }
    }, [userId])

    const getSalaryHistory = useCallback(async (page = 1, limit = 10) => {
        const res = await getData(`/salary/user`, { userId, page, limit })
        setSalaryHistory(res.data)
    }, [userId])
    useEffect(() => {
        if (userId) {
            getpaymentData()
            getPaymentHistory()
            getSalaryHistory()
        }
    }, [getPaymentHistory, getSalaryHistory, getpaymentData, userId])

    useEffect(() => {
        getUsers()
    }, [])

    const handleTabChange = (key) => {
        console.log('Selected Tab:', key);
    };

    const columns = [
        {
            title: "Paiement",
            dataIndex: "payment",
            key: "payment",
        },
        {
            title: "Total Commandes livrees",
            dataIndex: "totalDeliveredOrders",
            key: "totalDeliveredOrders",
        },
        {
            title: "Total UpSell",
            dataIndex: "totalUnitsUpSell",
            key: "totalUnitsUpSell",
        },
        {
            title: "Total Crossel",
            dataIndex: "totalUnitsCruSell",
            key: "totalUnitsCruSell",
        },
        {
            title: "Date de paiement",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => <div>{moment(text).format('YYYY-MM-DD')}</div>
        },
    ]

    const paySalaray = async () => {
        try {
            const res = await updateData(`/salary/user/${userId}`)
            if (res.status === 200) {
                getSalaryHistory()
            }
        } catch (error) {

        }
    }

    const salaryColumns = [
        {
            title: "Salaire",
            dataIndex: "salary",
            key: "salary",
        },
        {
            title: "Mois",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => <div>{moment(text).subtract(1, 'month').format('YYYY-MM')}</div>
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (text, record) => {
                return (
                    <>
                        {record.isPayed ? <Button type="primary" disabled>Payé</Button> : <Button onClick={() => paySalaray()} type="primary">Payer</Button>}
                    </>
                )
            },
        }
    ]

    const getDataOfTheMonth = async (date) => {
        try {
            const res = await getData('payment/month', { date, userId })
            setMonthPaymentData(res.data)
        } catch (error) {
            console.log(error)
        }
    }

    const addPayment = async (payment) => {
        try {
            await postData('/payment', {
                user: parseInt(userId),
                payment,
                totalUnitsUpSell: paymentData.totalUnitsUpSell,
                totalDeliveredOrders: paymentData.totalDeliveredOrders,
                totalUnitsCruSell: paymentData.totalUnitsCruSell,
            })
            getPaymentHistory()
            getpaymentData()
        } catch (error) {

        }
    }

    return (
        <>
            <Row>
                <Col span={8}>
                    <Formik
                        initialValues={{ userId: null }}
                        validationSchema={Yup.object({
                            userId: Yup.number().required('required'),
                        })}
                        onSubmit={(values, _) => {
                            setUserId(values.userId)
                        }}
                    >
                        <Form>
                            <Row gutter={[16, 16]}>
                                <Col span={24} style={{ textAlign: "left" }}>Selectionner un emplyee</Col>
                                <Col span={12}>
                                    <SelectInput
                                        name="userId"
                                        size="large"
                                        placeholder={"Emplyee"}
                                        options={users}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Button size='large' type="primary" htmlType="submit">
                                        Selectionner
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Formik>
                </Col>
                {userId && <Col span={8}>
                    <Formik
                        initialValues={{ payment: null }}
                        validationSchema={Yup.object({
                            payment: Yup.number().required('required'),
                        })}
                        onSubmit={(values, submitProps) => {
                            addPayment(values.payment)
                        }}
                    >
                        <Form>
                            <Row gutter={[16, 16]}>
                                <Col span={24} style={{ textAlign: "left" }}>Ajouter paiement</Col>
                                <Col span={12} >
                                    <TextInput
                                        name="payment"
                                        placeholder="Montant"
                                        size="large"
                                    />
                                </Col>
                                <Col span={8}>
                                    <Button size='large' type="primary" htmlType="submit">
                                        Ajouter
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Formik>
                </Col>}
                {userId && <Col span={8}>
                    <Formik
                        initialValues={{ payment: null }}
                        validationSchema={Yup.object({
                            date: Yup.date().required('required'),
                        })}
                        onSubmit={(values, submitProps) => {
                            getDataOfTheMonth(values.date)
                        }}
                    >
                        <Form>
                            <Row gutter={[16, 16]}>
                                <Col span={24} style={{ textAlign: "left" }}>Chercher par mois</Col>
                                <Col span={12} >
                                    <DateInput
                                        name="date"
                                        placeholder="Mois"
                                        size="large"
                                        picker="month"
                                    />
                                </Col>
                                <Col span={8}>
                                    <Button size='large' type="primary" htmlType="submit">
                                        chercher
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Formik>
                </Col>}
            </Row>
            {paymentData && <>
                <Divider>Statisque des tous les commandes</Divider>
                <Row gutter={[14, 20]} style={{ marginTop: 10 }}>
                    <PaymentCard
                        value={paymentData.paymentPerOrder + " DH"}
                        title="Paiement commandes"
                        icon={<DollarOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.paymentPerUpSell + " DH"}
                        title="Paiement UpSell"
                        icon={<DollarOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.totalUnitsUpSell}
                        title="total UpSell"
                        icon={<NumberOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.totalUnitsCruSell}
                        title="total CruSell"
                        icon={<NumberOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.totalDeliveredOrders}
                        title="commandes livrées"
                        icon={<NumberOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.totalPayed + " DH"}
                        title="total payé"
                        icon={<DollarOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.totalToPay + " DH"}
                        title="Total à payer"
                        icon={<DollarOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.totalUnitsCruSellPayment + " DH"}
                        title="paiement CruSell"
                        icon={<DollarOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.restToPay + " DH"}
                        title="Le reste à payer"
                        icon={<DollarOutlined />}
                    />
                </Row>
                <Divider>Statisque des nouveau commandes</Divider>
                <Row gutter={[14, 20]} style={{ marginTop: 10 }}>
                    <PaymentCard
                        value={paymentData.newPaymentPerOrders + " DH"}
                        title="Paiement commandes"
                        icon={<DollarOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.newUpSellOrdersPayment + " DH"}
                        title="Paiement UpSell"
                        icon={<DollarOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.newUpSellOrders}
                        title="UpSell"
                        icon={<NumberOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.newCruSellOrders}
                        title="CruSell"
                        icon={<NumberOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.newCruSellOrdersPayment + " DH"}
                        title="paiement CruSell"
                        icon={<DollarOutlined />}
                    />
                    <PaymentCard
                        value={paymentData.newDeliverOrdersCount}
                        title="commandes livrées"
                        icon={<NumberOutlined />}
                    />
                </Row>
            </>}
            {monthPaymentData &&
                <> 
                    <Divider>Statisque des commandes du mois</Divider>
                    <Row gutter={[14, 20]} style={{marginTop:10}}>
                        <PaymentCard
                            value={monthPaymentData.totalDeliveredOrders}
                            title="commandes livrées"
                            icon={<NumberOutlined />}
                        />
                        <PaymentCard
                            value={monthPaymentData.totalUnitsUpSell}
                            title="UpSell"
                            icon={<NumberOutlined />}
                        />
                        <PaymentCard
                            value={monthPaymentData.totalUnitsCruSell}
                            title="CruSell"
                            icon={<NumberOutlined />}
                        />
                        <PaymentCard
                            value={monthPaymentData.paymentPerOrders+" DH"}
                            title="Paiement commandes"
                            icon={<DollarOutlined />}
                        />
                        <PaymentCard
                            value={monthPaymentData.paymentPerUpSell+" DH"}
                            title="Paiement UpSell"
                            icon={<DollarOutlined />}
                        />
                        <PaymentCard
                            value={monthPaymentData.totalUnitsCruSellPayment+" DH"}
                            title="Paiement CruSell"
                            icon={<DollarOutlined />}
                        />
                    </Row>
                </>
            }
            <Tabs defaultActiveKey="1" onChange={handleTabChange}>
                <TabPane tab="historique des paiements" key="1">
                    <TableLayout
                        columns={columns}
                        total={paymentHistory.total}
                        dataSource={paymentHistory.payments}
                        getData={getPaymentHistory}
                        displayAddBtn={true}
                    />
                </TabPane>
                <TabPane tab="Salaire" key="2">
                    <TableLayout
                        columns={salaryColumns}
                        total={salaryHistory.total}
                        dataSource={salaryHistory.salary}
                        getData={getSalaryHistory}
                        displayAddBtn={true}
                    />
                </TabPane>
            </Tabs>
        </>
    );
}

export default ManagementPayment;